import React from 'react'

import NoNotification from './NoNotification'
import NotificationPanel from '../../NotificationPanel'

const NotificationItem = ({ id, options, LIMIT, onMobile, onSelect }) => {
  if (!id) {
    return <NoNotification />
  }

  const notifIndex = options.findIndex(n => n.id === id)

  return (
    <NotificationPanel
      key={id}
      notification={options[notifIndex]}
      isLast={[options.length - 1, LIMIT - 1].includes(notifIndex)}
      onMobile={onMobile}
      onSelect={onSelect}
    />
  )
}

export default NotificationItem
